import type { ReactNode } from "react";

export function ContentFrame({ children }: { children: ReactNode }) {
  return (
    <div className="relative min-h-screen">
      <BackgroundLayers />
      <div className="mx-auto max-w-[1640px] px-11 pb-10 pt-7">{children}</div>
    </div>
  );
}

function BackgroundLayers() {
  return (
    <>
      {/* Horizon glow — large blurred ellipse anchored below viewport bottom */}
      <div
        aria-hidden
        className="pointer-events-none fixed -z-10"
        style={{
          bottom: "-380px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "1400px",
          height: "780px",
          background:
            "radial-gradient(ellipse at center, rgba(232,121,249,0.28) 0%, rgba(168,85,247,0.18) 22%, rgba(126,34,206,0.08) 45%, transparent 70%)",
          filter: "blur(36px)",
        }}
      />
      {/* Bright horizon line */}
      <div
        aria-hidden
        className="pointer-events-none fixed -z-10"
        style={{
          bottom: "30vh",
          left: "50%",
          transform: "translateX(-50%)",
          width: "160vw",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent 0%, rgba(232,121,249,0.08) 20%, rgba(232,121,249,0.9) 48%, rgba(255,255,255,0.95) 50%, rgba(232,121,249,0.9) 52%, rgba(232,121,249,0.08) 80%, transparent 100%)",
          filter: "blur(0.5px)",
          boxShadow: "0 0 12px rgba(232,121,249,0.8), 0 0 40px rgba(232,121,249,0.4)",
        }}
      />
      {/* Film grain */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 -z-10 opacity-35 mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='240' height='240'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0.92 0 0 0 0 0.65 0 0 0 0 0.98 0 0 0 0.22 0'/></filter><rect width='240' height='240' filter='url(%23n)'/></svg>\")",
        }}
      />
      {/* Vignette */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 -z-10"
        style={{
          background: "radial-gradient(ellipse at center, transparent 50%, rgba(0,0,0,0.6) 100%)",
        }}
      />
    </>
  );
}
